import React, { useRef, useState } from "react";
import { Button } from "../button";
import styles from "./file-input.module.scss";

const MAX_SIZE = 2 * 1024 * 1024; // 2MB

export interface FileInputProps {
	value?: File | null;
	onChange: (file: File | null) => void;
	accept?: string;
	placeholder?: string;
	className?: string;
}

export const FileInput: React.FC<FileInputProps> = ({
	value,
	onChange,
	accept = "image/*",
	placeholder = "No file selected",
	className = "",
}) => {
	const inputRef = useRef<HTMLInputElement>(null);
	const [sizeError, setSizeError] = useState<string | null>(null);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files?.[0];
		if (!file) return;
		if (file.size > MAX_SIZE) {
			setSizeError("Image must be 2MB or less");
			e.target.value = "";
			return;
		}
		setSizeError(null);
		onChange(file);
	};

	return (
		<div className={`${styles.fileInputRow} ${className}`}>
			<div className={`${styles.fileDisplay} ${value ? styles.hasFile : ""}`}>
				<span className={styles.fileName}>{value ? value.name : placeholder}</span>
			</div>
			<Button size="small" variant="secondary" className={styles.selectButton} onClick={() => inputRef.current?.click()}>
				Select
			</Button>
			<input
				ref={inputRef}
				type="file"
				accept={accept}
				className={styles.hiddenInput}
				onChange={handleChange}
			/>
			{sizeError && <span className={styles.errorText}>{sizeError}</span>}
		</div>
	);
};